import TYPES from '../product-types';
import { DIR } from 'core/constants';
import Copy from '@resn/gozer-core/copy';

export default [
    // ************************************************************
    //
    // XP1
    //
    // ************************************************************
    {
        id: 'xp1-downpayment',
        type: TYPES.XP1,
        // remove cart
        // cartTitle: Copy.get('cart-xp1-item-downpayment'),
        // cartDesc: Copy.get('cart-xp1-item-downpayment-desc'),
        // cartImage: `${DIR.IMG}products/cart/xp1-thumb.png`,
        gallery: [
            { type: 'img', src: `${DIR.IMG}products/xp1/xp1-configure-1.png` },
            { type: 'img', src: `${DIR.IMG}products/xp1/xp1-configure-2.png` },
            { type: 'img', src: `${DIR.IMG}products/xp1/xp1-configure-3.png` },
            { type: 'img', src: `${DIR.IMG}products/xp1/xp1-configure-4.png` },
            { type: 'img', src: `${DIR.IMG}products/xp1/xp1-configure-5.png` },
        ],
        thumbs: [
            `${DIR.IMG}products/xp1/xp1-configure-thumb-1.png`,
            `${DIR.IMG}products/xp1/xp1-configure-thumb-2.png`,
            `${DIR.IMG}products/xp1/xp1-configure-thumb-3.png`,
            `${DIR.IMG}products/xp1/xp1-configure-thumb-4.png`,
            `${DIR.IMG}products/xp1/xp1-configure-thumb-5.png`,
        ],
    },

    // XP1 SUBSCRIPTIONS
    {
        id: 'xp1-sub-yearly',
        type: TYPES.XP1_SUBSCRIPTION,
        title: 'OXEFIT',
        desc: 'One Year Software Subscription',
        // remove cart
        // cartTitle: Copy.get('cart-xp1-item-subscription-title'),
        // cartDesc: Copy.get('cart-xp1-item-subscription-desc'),
        // cartImage: `${DIR.IMG}products/cart/oxefit-subscription.jpg`,
        available: true,
        thumbs: [`${DIR.IMG}products/xs1/xs1-panel-accessories-image.png`],
    },

    // XP1 BARS
    {
        id: 'xp1-bar-light',
        type: TYPES.XP1_BAR,
        title: 'Light',
        desc: 'Ideal for light to moderate loads',
        // remove cart
        // cartTitle: Copy.get('cart-xp1-item-bar-1'),
        // cartDesc: Copy.get('cart-xp1-item-bar1-desc'),
        // cartImage: `${DIR.IMG}products/cart/xp1-workout-bar-light-thumb.jpg`,
        available: true,
        thumbs: [`${DIR.IMG}products/xp1/xp1-workout-bar-light.png`],
    },
    {
        id: 'xp1-bar-standard',
        type: TYPES.XP1_BAR,
        title: 'Standard',
        desc: 'Ideal for moderate to heavy loads',
        // remove cart
        // cartTitle: Copy.get('cart-xp1-item-bar-2'),
        // cartDesc: Copy.get('cart-xp1-item-bar-2-desc'),
        // cartImage: `${DIR.IMG}products/cart/xp1-workout-bar-standard-thumb.jpg`,
        available: true,
        thumbs: [`${DIR.IMG}products/xp1/xp1-workout-bar-standard.png`],
    },
    {
        id: 'xp1-bar-advanced',
        type: TYPES.XP1_BAR,
        title: 'Advanced',
        desc: 'Ideal for heavy loads',
        // remove cart
        // cartTitle: Copy.get('cart-xp1-item-bar'),
        // cartDesc: Copy.get('cart-xp1-item-bar-3-desc'),
        // cartImage: `${DIR.IMG}products/cart/xp1-workout-bar-advanced-thumb.jpg`,
        available: true,
        thumbs: [`${DIR.IMG}products/xp1/xp1-workout-bar-advanced.png`],
    },
    {
        id: 'xp1-bar-all',
        type: TYPES.XP1_BAR,
        title: 'All Bars',
        desc: 'Select all above types',
        // remove cart
        // cartTitle: Copy.get('cart-xp1-item-bar-4'),
        // cartDesc: Copy.get('cart-xp1-item-bar-4-desc'),
        // cartImage: `${DIR.IMG}products/cart/xp1-workout-bar-all-thumb.jpg`,
        available: true,
        thumbs: [`${DIR.IMG}products/xp1/xp1-workout-bar-all.png`],
    },
];
